import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// RTL languages
const rtlLanguages = ['ar', 'he'];

// Get saved language preference
const savedLanguage = localStorage.getItem('preferredLanguage');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: savedLanguage || 'en', // Use saved language if available
    supportedLngs: ['en', 'es', 'zh', 'hi', 'ar', 'pt', 'ru', 'ja', 'he', 'de', 'it', 'fr'],
    debug: false, // Disable debug logs
    
    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      lookupFromPathIndex: 0,
    },
  });

// Function to check if current language is RTL
export const isRTL = () => {
  return rtlLanguages.includes(i18n.language);
};

export default i18n; 